export default "__VITE_ASSET__afe4f5d1__"